module.exports = __webpack_public_path__ + "img/twitter.ce90b268.svg";